export const SOURCE = "source";
export const TARGET = "target";
export const KNOW = 21;
export const ISSUE = 122;
export const PAPER = 2;
export const ASSIST = 101;
export const ASSISTKNOW = 1001;
export const KNOWLEDGEWITHISSUE = 26;
export const ALBUM = 3;

export const ALLOWTYPE = {
    [KNOW] : "知识点",
    [ISSUE] : "考点",
    [PAPER] : "试卷",
    [ASSIST] : "章节",
    [KNOWLEDGEWITHISSUE] : "知识点及考点",
    [ALBUM] : "专辑",
}


export const QUESTIONFILTER = [
    {type:"difficult", name:"难度"},
    {type:"systemtype", name:"题目类型"},
    {type:"displaytypelist", name:"展示类型"},
    {type:"hot", name:"热度"},
    {type:"rightrate", name:"正确率"},
    {type:"onlinestatus", name:"上线状态"},
]

export const KOTM = [
    {value:"editionList", name:"教材"},
    {value:"bookList", name:"课本"},
    {value:"bookAssistList", name:"教辅"},
    {value:"sectionKnowList", name:"关联关系树"},
]

export const GRADE = {
    PRIMARY:'10',//小学
    JUNIOR:'20',//初中
    SENIOR:'30',//高中
}

export const GRADE_PART = {
    [GRADE.PRIMARY]:'小学',
    [GRADE.JUNIOR]:'初中',
    // [GRADE.SENIOR]:'高中',
}

export const SUBJECT = {
    MATH: '0',
    CHINESE:'1',
    ENGLISH:'2',
    PHYSICS:'3',
    CHEMISTRY:'4',
    BIOLOGY:'5',
    HISTORY:'6',
    GEOGRAPHY:'7',
    POLITICAL:'8',
    IT:'9',
    SCIENCE:'10',
    XIAOXIANG_PROGRAM: '50',
    SUZHIKE_PROGRAM: '51',
}

export const SUBJECT_PART = {
    [SUBJECT.MATH]: '数学',
    [SUBJECT.CHINESE]: '语文',
    [SUBJECT.ENGLISH]: '英语',
    // [SUBJECT.PHYSICS]: '物理',
    // [SUBJECT.CHEMISTRY]: '化学',
    // [SUBJECT.BIOLOGY]: '生物',
    // [SUBJECT.HISTORY]: '历史',
    // [SUBJECT.GEOGRAPHY]: '地理',
    // [SUBJECT.POLITICAL]: '政治',
    // [SUBJECT.IT]: '信息技术',
    [SUBJECT.SCIENCE]: '科学',
    [SUBJECT.XIAOXIANG_PROGRAM]: '小象编程',
    [SUBJECT.SUZHIKE_PROGRAM]: '素质课',

}
export const SUBJECT_PART_TO_STRING = {
    [SUBJECT.MATH]: 'math',
    [SUBJECT.CHINESE]: 'chinese',
    [SUBJECT.ENGLISH]: 'english',
    // [SUBJECT.PHYSICS]: '物理',
    // [SUBJECT.CHEMISTRY]: '化学',
    // [SUBJECT.BIOLOGY]: '生物',
    // [SUBJECT.HISTORY]: '历史',
    // [SUBJECT.GEOGRAPHY]: '地理',
    // [SUBJECT.POLITICAL]: '政治',
    // [SUBJECT.IT]: '信息技术',
    [SUBJECT.SCIENCE]: 'science',
    [SUBJECT.XIAOXIANG_PROGRAM]: 'xiaoxiang_program',
    [SUBJECT.SUZHIKE_PROGRAM]: '素质课_program',

}
export const SUBJECT_STEM_STYLE = {
    [SUBJECT.MATH]: [
        {"type_name": "引导语", "type_style": "math_guide"},
        {"type_name": "题干文字", "type_style": "math_text"},
        {"type_name": "题干图片", "type_style": "math_picture"},
        {"type_name": "题干音频", "type_style": "math_audio"},
        {"type_name": "题干提示文字", "type_style": "math_tiptext"},
        {"type_name": "脱式题干", "type_style": "delivery_equation"},
    ],
    [SUBJECT.CHINESE]: [
        {"type_name": "阅读题干", "type_style": "chinese_paratext"},
        {"type_name": "引导语", "type_style": "chinese_guide"},
        {"type_name": "题干文字", "type_style": "chinese_text"},
        {"type_name": "题干图片", "type_style": "chinese_picture"},
        {"type_name": "题干音频", "type_style": "chinese_audio"},
        {"type_name": "题干提示文字", "type_style": "chinese_tiptext"},
        {"type_name": "朗读题题干", "type_style": "chinese_read"},
        {"type_name": "背诵题题干", "type_style": "chinese_recite"},
        {"type_name": "带拼音朗读题", "type_style": "chinese_read_pinyin"},
        {"type_name": "带拼音背诵题", "type_style": "chinese_recite_pinyin"},
        {"type_name": "带拼音背诵古诗", "type_style": "chinese_recite_pinyin_poem"},
        {"type_name": "带拼音朗读古诗", "type_style": "chinese_read_pinyin_poem"},
        {"type_name": "纯拼音朗读题干", "type_style": "chinese_read_pure_pinyin_center"},
    ],
    [SUBJECT.ENGLISH]: [
        {"type_name": "引导语", "type_style": "english_guide"},
        {"type_name": "题干文字", "type_style": "english_text"},
        {"type_name": "题干图片", "type_style": "english_picture"},
        {"type_name": "题干音频", "type_style": "english_audio"},
        {"type_name": "题干提示文字", "type_style": "english_tiptext"},
        {"type_name": "单词挖空", "type_style": "english_blank"},
        {"type_name": "单词全拼", "type_style": "english_spell"},
        {"type_name": "连词成句输入区", "type_style": "english_sentence"},
        {"type_name": "朗读题题干", "type_style": "english_read"},
        {"type_name": "背诵题题干", "type_style": "english_recite"},
    ],
    [SUBJECT.SCIENCE]: [
        {"type_name": "引导语", "type_style": "science_guide"},
        {"type_name": "题干文字", "type_style": "science_text"},
        {"type_name": "题干图片", "type_style": "science_picture"},
        {"type_name": "题干音频", "type_style": "science_audio"},
        {"type_name": "题干提示文字", "type_style": "science_tiptext"},
    ],
    [SUBJECT.XIAOXIANG_PROGRAM]: [
        {"type_name": "引导语", "type_style": "program_guide"},
        {"type_name": "题干文字", "type_style": "program_text"},
        {"type_name": "题干图片", "type_style": "program_picture"},
        {"type_name": "题干音频", "type_style": "program_audio"},
        {"type_name": "题干提示文字", "type_style": "program_tiptext"},
    ],
    [SUBJECT.SUZHIKE_PROGRAM]: [
        {"type_name": "引导语", "type_style": "math_guide"},
        {"type_name": "题干文字", "type_style": "math_text"},
        {"type_name": "题干图片", "type_style": "math_picture"},
        {"type_name": "题干音频", "type_style": "math_audio"},
        {"type_name": "题干提示文字", "type_style": "math_tiptext"},
        {"type_name": "脱式题干", "type_style": "delivery_equation"},
    ],
}

export const TOOLBARS = {
    excludeCn: ['source','formula'],
    commonFormula:[
        'insert_vertical','|'
    ],
    mathFormula:[
       'fillin_delivery'
    ],
    excludeCn1: ['insert_dot'],
    mathAnswer:[
        'insert_gt', 'insert_lt','|',
        'insert_add','insert_minus','insert_multiply','insert_divide','insert_equal',

    ],
    otherFormula: [
        'fillin_line','fillin_letter','fillin_express'
    ],
    englishFormula: [
        'fillin_multiline','insert_2_','insert_8_'
    ],
    blankImgAudio:[
        '|', 'image','audition_upload'
    ],
    excludeCn2: ['audition_upload2'],
    audioFormule: ['audiogenerator'],
    pinyin:['cn_pinyin'],
    aiTools:['fillin_equation']

}
export const getToolbars = (subject,type,product,...args)=>{
	// 判断是否是英语科目0-数学，1-语文，2-英语科目，
    let arr = [];
    if(subject === '0'){
        arr.push(...TOOLBARS.excludeCn)
    }



    if (subject !== '1' && subject !== '2') {
        arr.push(...TOOLBARS.excludeCn1)
    }
    if(args&&args.length){
        arr.push(...args)
    }
    if(type==='stem'||type==='answer'){
        if (subject === '2' || subject === '1'){
        }
        else {
            arr.push(...TOOLBARS.mathAnswer)
        }

    }
    

    if (type==='stem') {
    		arr.push(...TOOLBARS.commonFormula)
    		if(subject === '0'){
    			arr.push(...TOOLBARS.mathFormula)
    		}
        if (subject === '0' || subject === '1'){
            arr.push(...TOOLBARS.otherFormula)
        } else {
            arr.push(...TOOLBARS.otherFormula, ...TOOLBARS.englishFormula);
        }
       
        if(subject == '0' && product == '4'){
        		arr.push(...TOOLBARS.aiTools)
        }
    }
    
    // end
    if(type==='stem'){
        arr.push(...TOOLBARS.blankImgAudio)
    }
    if (subject !== '1' && subject !== '2') {
        arr.push(...TOOLBARS.excludeCn2)
    }
    if(type==='stem'){
        arr.push(...TOOLBARS.audioFormule)
    }
    // 主观题 口语单词 口语短语 口语句子 口语段落
    if(['subjectivityAnswer','spokenWordsAnswer','spokenPhrasesAnswer','spokenSentencesAnswer','spokenPassageAnswer','spokenPinyinAnswer','spokenPhoneticAnswer','semiOpenAnswer','spokenPassageCnAnswer','spokenPhrasesCnAnswer','spokenSentencesCnAnswer'].includes(type)){
        arr.push(...TOOLBARS.mathAnswer,...TOOLBARS.commonFormula, ...TOOLBARS.blankImgAudio)
    }
    
    return arr
}


export const ONLINE_STATUS_NOTONLINE = 0;
export const ONLINE_STATUS_WAITONLINE = 1;
export const ONLINE_STATUS_ONLINED = 2;
export const ONLINE_STATUS_WAITOFFLINE = 3;
export const ONLINE_STATUS_OFFLINE = 4;

export const ONLINESTATUS = {
    [ONLINE_STATUS_NOTONLINE]:'不上线',
    [ONLINE_STATUS_WAITONLINE]:'待上线',
    [ONLINE_STATUS_ONLINED]:'已上线',
    [ONLINE_STATUS_WAITOFFLINE]:'待下线',
    [ONLINE_STATUS_OFFLINE]:'已下线'
};

export const QUESTIONSTAGE = { "1": "阅读理解", "2": "推理分析", "3": "列式解答" };
export const STAGE_TAG = { "1": "阅读", "2": "推理", "3": "列式" };


// WEBPACK FOOTER //
// ./src/utils/questionManageType.js